import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/constants/api-constants';
import { HttpGuardService } from 'src/app/guards/http-guard.service';

@Injectable({
  providedIn: 'root'
})
export class ProtusServiceService {

  constructor(private httpGuard: HttpGuardService) { }

  /**
   * Gets protus list
   * @param pageNo 
   * @param payload 
   * @returns  
   */
  getProtusList(offset: any, payload: {limit?: number, searchKey?: string, from?: string, to?: string, dtcId?: string}) {
    let httpParams = new HttpParams();
    if (payload?.limit) {
      httpParams = httpParams?.set('limit', payload?.limit);
    }
    if (payload?.searchKey) {
      httpParams = httpParams?.set('searchKey', payload?.searchKey);
    }
    if (payload?.from) {
      httpParams = httpParams?.set('from', payload?.from);
    }
    if (payload?.to) {
      httpParams = httpParams?.set('to', payload?.to);
    }
    if (payload?.dtcId) {
      httpParams = httpParams?.set('dtcId', payload?.dtcId);
    }
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', `${ApiConstants.URL.getProtusV2}/${offset}`, httpParams?.toString() ? '?' + httpParams?.toString() : null, true);
  }

  /**
   * Gets protus aggregate list
   * @param aggregate 
   * @returns  
   */
  getProtusAggregateList(aggregate: string) {
    let httpParams = new HttpParams();
    if (aggregate) {
      httpParams = httpParams?.set('aggregate', aggregate);
    }
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', `${ApiConstants.URL.protusAggregate}`, httpParams?.toString() ? '?' + httpParams?.toString() : null, true);
  }

  downloadProtusFile(fileName: string) {
    const param = '?documentName=' + fileName;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', `${ApiConstants.URL.downloadProtusFile}`, param, false);
  }

  /**
   * Updates protus
   * @param file 
   * @param id 
   * @returns  
   */
  updateProtus(file: any, id: string) {
    return this.httpGuard.httpReq('put', 'API_ENDPOINT', `${ApiConstants.URL.updateProtusV2}/${id}`, file, true, 'response');
  }

  protusReoccurence(payload: any, id: string) {
    return this.httpGuard.httpReq('put', 'API_ENDPOINT', `${ApiConstants.URL.protusReoccurence}/${id}`, payload, true, 'response');
  }
}